// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"004d479d","545":"146ff534","551":"a22a53b6","605":"0d99fc60","662":"32ebd6a5","766":"ad27e1e7"}[chunkId] + ".chunk.js";
};